<!-- <app-pagetitle title="{{'PAGE.REPORT.IncidentType' | translate}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle> -->

<div class="card">
  <div class="card-body">
    <h5>{{'DANH SÁCH NGƯỜI DÙNG' | translate}}</h5>
    <div class="row mb-md-2">
      <div class="form-group col-3">
        <label>{{'Từ khoá' | translate}}</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.keyword"
          placeholder="{{'Nhập từ khoá tìm kiếm' | translate}}"
        />
      </div>
      <div class="form-group col-3">
        <label>{{'Vai trò' | translate}}</label>
        <ng-select [(ngModel)]="filter.role_id" [clearable]="true">
          <ng-option value="" hidden>{{'Vai trò' | translate}}</ng-option>
          <ng-option
            *ngFor="let item of listRoles"
            [value]="item.id"
            >{{item.name}}</ng-option
          >
        </ng-select>
      </div>
      <div class="form-group col-3 d-flex align-items-end">
        <button class="btn btn-primary" (click)="submitFilter()">
          {{'Tìm kiếm' | translate}}
        </button>
        <button class="btn btn-dark ml-2" (click)="clearFilter()">
          {{'FORM.Clear' | translate}}
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive no-footer dtr-inline table-wrap"
      >
        <thead>
          <tr class="bg-table">
            <th width="50">#</th>
            <th width="120">{{'Số điện thoại' | translate}}</th>
            <th width="150">{{'Họ tên' | translate}}</th>
            <th width="90">{{'Vai trò' | translate}}</th>
            <th width="250">{{'Địa chỉ' | translate}}</th>
            <th width="300">{{'Token' | translate}}</th>
            <th width="120">{{'Ngày tạo' | translate}}</th>
          </tr>
        </thead>
        <tbody *ngFor="let data of listData;let i=index">
          <tr>
            <td><a>{{pageSize*(pageIndex-1) +i+1}}</a></td>
            <td><a>{{data.phone}}</a></td>
            <td><a>{{data.full_name}}</a></td>
            <td><a>{{data.role}}</a></td>
            <td><a>{{data.address}}</a></td>
            <td><a>{{data.user_token}}</a></td>
            <td><a>{{data.created_at | date:'dd/MM/yyyy HH:mm':'GMT'}}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{'TABLE.Showing' | translate}} {{pageSize*pageIndex - pageSize + 1}}
          {{'TABLE.to' | translate}} {{pageSize*pageIndex}} {{'TABLE.of' |
          translate}} {{totalCount}} {{'TABLE.entries' | translate}}
        </div>
      </div>
      <!-- Pagination -->
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{'TABLE.Show' | translate}}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1;fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{'TABLE.entries' | translate}}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #contentKeyword let-modalHis="close">
  <div class="modal-header">
    <h5 class="modal-title">List keyword of "{{selectedIncident.name}}"</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalHis('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="mb-3" *ngIf="formNewKeyword">
      <h5 class="font-size-14">Add New Keyword</h5>
      <form
        [formGroup]="formNewKeyword"
        (submit)="onSubmitFormKeyword(2)"
        class="d-flex"
      >
        <input
          type="text"
          class="form-control form-control-sm"
          style="width: 250px;"
          formControlName="name"
        />
        <button class="btn btn-primary btn-sm ml-3" style="width: 150px;">
          Add
        </button>
      </form>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
      >
        <thead>
          <tr>
            <th width="50">#</th>
            <th>Name</th>
            <!-- <th>Thời gian</th> -->
            <th width="170"></th>
          </tr>
        </thead>
        <tbody *ngFor="let data of dataKeyword;let i=index">
          <tr>
            <td>{{i+1}}</td>
            <td>
              <ng-container
                *ngIf="selectedKeyword?.id == data.id && formEditKeyword; else normal"
              >
                <form
                  [formGroup]="formEditKeyword"
                  (submit)="onSubmitFormKeyword(1)"
                >
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="name"
                  />
                </form>
              </ng-container>
              <ng-template #normal>{{data.name}}</ng-template>
            </td>
            <!-- <td>{{data.created_at*1000 | date:'dd/MM/yyyy HH:mm'}}</td> -->
            <td>
              <div class="d-flex" style="gap: 10px;">
                <a
                  class="btn btn-sm btn-success"
                  href="javascript: void(0);"
                  (click)="editKeyword(data,i)"
                >
                  <i class="mdi mdi-account-edit"></i>{{'FORM.Edit' |
                  translate}}</a
                >
                <a
                  class="text-white btn btn-sm btn-danger"
                  (click)="onDeleteKeyword(data.id)"
                  ><i class="mdi mdi-delete"></i>{{'FORM.Delete' |
                  translate}}</a
                >
              </div>
              <!-- <button class="btn" (click)="editKeyword(data,i)">Sửa</button>
                            <button>Xoá</button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
